module.exports = __webpack_public_path__ + "img/comreview_illustration.65088f57.svg";